import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import authService from '../../services/auth.service'

// Rutas públicas que no requieren autenticación
const publicRoutes = ['consulta', 'login', 'signup', 'recover-password', 'recover-password-email']

export const authGuard = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  console.log('Guard ejecutándose para ruta:', to.fullPath)

  const isPublicRoute = publicRoutes.includes(to.name as string)
  console.log('Ruta actual:', { name: to.name, isPublic: isPublicRoute })

  try {
    // Verificar autenticación (incluye verificación del token con el backend)
    const isAuthenticated = await authService.isAuthenticated()
    console.log('Estado de autenticación:', isAuthenticated)

    // Si la ruta requiere autenticación y no está autenticado
    if (!isPublicRoute && !isAuthenticated) {
      console.log('Acceso denegado: redirigiendo a login')
      return next({
        name: 'login',
        query: { redirect: to.fullPath },
        replace: true,
      })
    }

    // Si está autenticado y trata de acceder a una ruta pública
    if (isPublicRoute && isAuthenticated) {
      console.log('Usuario autenticado en ruta pública: redirigiendo a dashboard')
      return next({ name: 'dashboard' })
    }

    // En cualquier otro caso, permitir la navegación
    console.log('Navegación permitida')
    return next()
  } catch (error) {
    console.error('Error en la verificación de autenticación:', error)
    return next({
      name: 'login',
      query: { redirect: to.fullPath },
      replace: true,
    })
  }
}
